module.exports = __webpack_public_path__ + "static/media/questioner-walk.1e27a724.gif";